import { render, staticRenderFns } from "./QueryTag.vue?vue&type=template&id=4f0c1022&scoped=true&"
import script from "./QueryTag.vue?vue&type=script&lang=js&"
export * from "./QueryTag.vue?vue&type=script&lang=js&"
import style0 from "./QueryTag.vue?vue&type=style&index=0&id=4f0c1022&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c1022",
  null
  
)

export default component.exports